const awsconfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scope: ["email", "openid", "profile"],
          //redirectSignIn: `${window.location.origin}/sessions`,
          //redirectSignOut: `${window.location.origin}/`,
          redirectSignIn:process.env.REACT_APP_REDIRECT_SIGNIN,
          redirectSignOut:process.env.REACT_APP_REDIRECT_SIGNOUT,
          responseType: "token",
        },
      },
    },
  },
};

export default awsconfig;
